import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import Size from "@builder/components/editable/style/Size";
import StyleGrid from "@builder/components/editable/style/StyleGrid";

const EditGrid = ({ parent }: EditableProps) => {
    return (
        <SidebarCollapse title="Payment grid" parent={parent}>
            <Size noWrapper />
            <StyleGrid noWrapper />
        </SidebarCollapse>
    );
};

export default EditGrid;
